module.exports = __webpack_public_path__ + "img/lalanitahome2v_h3.c79833ec.webp";